/* ETA SEOUL — Ajax cart drawer (Shopify Cart API)
   Requires: snippets/eta-cart-drawer.liquid rendered in theme.liquid */
(function(){
  var drawer = document.getElementById('etaDrawer');
  var scrim  = document.getElementById('etaScrim');
  if(!drawer) return;

  function money(cents){
    return '$' + (cents/100).toLocaleString('en-US', {minimumFractionDigits:0, maximumFractionDigits:2});
  }
  function open(){ drawer.classList.add('show'); scrim.classList.add('show'); }
  function close(){ drawer.classList.remove('show'); scrim.classList.remove('show'); }

  function render(cart){
    var lines = document.getElementById('etaLines');
    var foot  = document.getElementById('etaFoot');
    var bar   = document.getElementById('etaFreebar');

    // header counts (drawer + any element with [data-eta-cart-count])
    document.querySelectorAll('[data-eta-cart-count]').forEach(function(el){
      el.textContent = cart.item_count;
    });

    if(cart.item_count === 0){
      lines.innerHTML = '<div class="eta-drawer__empty">Your bag is empty.<br><a href="/collections/all" style="color:#000;text-decoration:underline">Continue shopping →</a></div>';
      foot.style.display = 'none'; bar.style.display = 'none';
      return;
    }
    foot.style.display = 'flex'; bar.style.display = 'block';

    lines.innerHTML = cart.items.map(function(it, i){
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') : '';
      return '<div class="eta-line">' +
        '<div class="eta-line__im">' + (img ? '<img src="'+img+'" alt="">' : '') + '</div>' +
        '<div class="eta-line__meta">' +
          '<div class="b">' + (it.vendor || '') + '</div>' +
          '<div class="n">' + it.product_title + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="n">Size — ' + it.variant_title + '</div>' : '') +
          '<span class="eta-qty">' +
            '<button data-eta-q="' + (i+1) + ':' + (it.quantity-1) + '">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button data-eta-q="' + (i+1) + ':' + (it.quantity+1) + '">+</button>' +
          '</span>' +
          '<button class="eta-line__rm" data-eta-q="' + (i+1) + ':0">Remove</button>' +
        '</div>' +
        '<div class="eta-line__pr">' + money(it.final_line_price) + '</div>' +
      '</div>';
    }).join('');

    var sub = cart.total_price;
    document.getElementById('etaSub').textContent = money(sub);
    document.getElementById('etaShip').textContent = 'EMS · at checkout';
    document.getElementById('etaTotal').textContent = money(sub);
  }

  function refresh(openAfter){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      render(c);
      if(openAfter) open();
    });
  }

  // qty change / remove
  document.addEventListener('click', function(e){
    var q = e.target.closest('[data-eta-q]');
    if(q){
      var parts = q.getAttribute('data-eta-q').split(':');
      fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ line: parseInt(parts[0],10), quantity: parseInt(parts[1],10) })
      }).then(function(r){ return r.json(); }).then(render);
      return;
    }
    if(e.target.closest('[data-eta-cart-open]')){ e.preventDefault(); refresh(true); return; }
    if(e.target.closest('#etaCheckout')){
      var consent = document.getElementById('etaConsent');
      if(consent && !consent.checked){
        e.preventDefault();
        var warn = document.getElementById('etaConsentWarn');
        if(warn) warn.classList.add('show');
      }
      return;
    }
    if(e.target.closest('#etaClose') || e.target === scrim){ close(); }
  });

  // quick add (single-variant) — buttons rendered by eta-product-card.liquid
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-eta-quick]');
    if(!btn) return;
    e.preventDefault(); e.stopPropagation();
    var vid = btn.getAttribute('data-eta-quick');
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id: parseInt(vid,10), quantity: 1 })
    }).then(function(){ btn.textContent = 'Added ✓'; refresh(true); })
      .catch(function(){ btn.textContent = 'Error — try PDP'; });
  });

  // intercept product form submits to open drawer instead of cart page
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action="/cart/add"]');
    if(!form) return;
    e.preventDefault();
    fetch('/cart/add.js', { method:'POST', body: new FormData(form) })
      .then(function(){ refresh(true); });
  });

  refresh(false);
})();
